import { Route } from '@angular/router';
import { AccountHooksComponent } from 'app/modules/settings/account-hooks/account-hooks.component';
import { AccountHookResolver, AccountHooksResolver } from 'app/modules/settings/account-hooks/account-hooks.resolvers';
import { AccountHooksDetailsComponent } from 'app/modules/settings/account-hooks/details/details.component';
import { AccountHooksListComponent } from 'app/modules/settings/account-hooks/list/list.component';
export const accountHooksRoutes: Route[] = [
  {
    path: '',
    component: AccountHooksComponent,
    resolve: {
      accountFunctions: AccountHooksResolver,
    },
    children: [
      {
        path: '',
        component: AccountHooksListComponent,
        resolve: {},
        children: [
          {
            path: ':id',
            component: AccountHooksDetailsComponent,
            resolve: {
              accountFunction: AccountHookResolver,
            },
          },
        ],
      },
    ],
  },
];
